// src/admin/components/LocationGroup.jsx
//
// Collapsible location section inside a client, e.g. "Pune — 3 Camps".
// Expands to a compact financial table of camps at that location.

import React, { useState } from 'react';
import AdminCampRow from './AdminCampRow';
import EmptyState from './EmptyState';

function IconChevronDown(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
    </svg>
  );
}

function IconMapPin(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

export default function LocationGroup({ location }) {
  const [open, setOpen] = useState(true);
  const camps = location?.camps || [];
  const campCount = location?.camp_count ?? camps.length;

  return (
    <div className="rounded-lg border border-[#E2E8E8] bg-[#F5F7F8]/60">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between px-4 py-2.5 text-left"
      >
        <span className="flex items-center gap-2 font-medium text-[#172B2B]">
          <IconMapPin className="h-4 w-4 text-[#11A8A4]" />
          {location?.location || 'Unknown Location'}
        </span>
        <span className="flex items-center gap-2 text-sm text-[#6B7C7C]">
          {campCount} camp{campCount === 1 ? '' : 's'}
          <IconChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>

      {open && (
        <div className="px-4 pb-4">
          {camps.length === 0 ? (
            <EmptyState
              title="No camps found"
              description="There are no active camps for this location."
            />
          ) : (
            <div className="admin-table-scroll rounded-lg border border-[#E2E8E8] bg-white">
              <table className="admin-camp-table min-w-full text-sm">
                <thead>
                  <tr className="text-left text-xs font-semibold uppercase tracking-wide">
                    <th className="px-4 py-2.5">Camp</th>
                    <th className="px-4 py-2.5">Location</th>
                    <th className="px-4 py-2.5">Dates</th>
                    <th className="px-4 py-2.5">Status</th>
                    <th className="px-4 py-2.5 text-right">Patients</th>
                    <th className="px-4 py-2.5 text-right">Billing</th>
                    <th className="px-4 py-2.5 text-right">Cost</th>
                    <th className="px-4 py-2.5 text-right">Profit</th>
                    <th className="px-4 py-2.5 text-right">Margin</th>
                    <th className="px-4 py-2.5 text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {camps.map((camp) => (
                    <AdminCampRow key={camp.id ?? camp.camp_id} camp={camp} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
